import {Alert, Label} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {SalesCampaignStatusFlag} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {getCampaignStatus} from '../utils/getCampaignStatus';

interface CampaignStatusProps extends RequiredTestIdProps {
  validFrom: Date | Nullish;
  validTo: Date | Nullish;
}

export function CampaignStatus(props: CampaignStatusProps) {
  const campaignStatus = getCampaignStatus(props.validFrom, props.validTo);

  return (
    <VStack>
      <Label>{i18n.t('entity.salesCampaign.labels.status')}</Label>

      {isNil(campaignStatus) ? (
        <Alert
          variant="info"
          type="inline"
          message={i18n.t('entity.salesCampaign.hints.statusPending')}
          data-testid={suffixTestId('statusPending', props)}
        />
      ) : (
        <HStack spacing={2} align="center" height={8}>
          <SalesCampaignStatusFlag status={campaignStatus} data-testid={props['data-testid']} />
          <Text size="xSmall" color="tertiary">
            {i18n.t('entity.salesCampaign.hints.statusDerived')}
          </Text>
        </HStack>
      )}
    </VStack>
  );
}
